let offers
let product
const requiresRebuild = true
let mulberryUpdate = false

function getCurrentlySelectedVariant (product) {
  if (product?.variants) {
    let selectedVariant = product.variants.find(
      (i) => i.id === window.mulberryShop.selectedVariantId
    )
    if (!selectedVariant) {
      selectedVariant = product.variants[0]
    }
    window.mulberryShop.selectedVariantId = selectedVariant.id
    return selectedVariant
  }
}

async function mulberryPdpInit () {
  if (window.location.href.includes('view=airsense-11-test')) {
    window.mulberry.core.settings.has_modal = false
    window.mulberry.core.settings.has_inline = true
  }

  const HAS_MODAL = window.mulberry.core.settings.has_modal
  const HAS_INLINE = window.mulberry.core.settings.has_inline
  if (window.location.pathname.indexOf('/products/') === -1) {
    return
  }

  if (!HAS_MODAL && !HAS_INLINE) {
    return
  }

  // A/B test: disable Mulberry modal when test flag is set
  if (window.sessionStorage.getItem('mulberry_test') === 'true') {
    return
  }

  const response = await window.mulberryShop.getProductData(
    window.mulberryShop.getProductUrl()
  )

  product = response.product

  const acceptedTypes = [
    'machine',
    'pap machines',
    'pap bundle',
    'PAP furniture',
    'mattress'
  ]

  if (acceptedTypes.includes(product.product_type)) {
    let selectedVariant = getCurrentlySelectedVariant(product)
    offers = await window.mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
    })

    console.log('Mulberry Inline', HAS_INLINE)

    if (HAS_INLINE) {
      window.pdpInline = await window.mulberry.inline.init({
        offers,
        settings: window.mulberry.core.settings,
        selector: '.mulberry-pdp-inline',
        placement: 'pdp',
        layout: {
          logo: false
        },
        onWarrantyToggle: async (warranty) => {
          window.mulberry.inline.isSelected = warranty.isSelected
          if (warranty.isSelected) {
            window.selectedOffer = warranty
          } else {
            window.selectedOffer = null
          }
        }
      })
    }

    if (HAS_MODAL) {
      window.pdpModal = await window.mulberry.modal.init({
        offers,
        settings: window.mulberry.core.settings,
        onWarrantySelect: async (warranty) => {
          const result = await window.mulberryShop.getWarrantyVariant(warranty)
          await window.mulberryShop.addWarrantyToCart(
            result.shopify_variant_id,
            {
              ...product,
              title: product.title,
              variantId: window.mulberryShop.selectedVariantId
            },
            warranty
          )

          window.mulberry.modal.close()
          // document.querySelector('.custom_drawer').classList.add('active')
        },
        onWarrantyDecline: async () => {
          window.mulberry.modal.close()
          // document.querySelector('.custom_drawer').classList.add('active')
        }
      })
    }

    document.addEventListener(
      'variant:change',
      async function (e) {
        window.selectedOffer = null
        window.pdpInline.deselectOffer()
        if (HAS_INLINE) {
          window.pdpInline.updateOffer([])
        }
        if (HAS_MODAL) {
          window.pdpModal.updateOffer([])
        }
        selectedVariant = e.detail.variant
        offers = await window.mulberry.core.getWarrantyOffer({
          id: selectedVariant.id,
          title: product.title,
          price: `${(selectedVariant.price / 100).toFixed(2)}`,
          detail: product
        })

        if (HAS_INLINE) {
          window.pdpInline.updateOffer(offers)
        }
        if (HAS_MODAL) {
          window.pdpModal.updateOffer(offers)
        }
      }
    )
  }
}

async function addWarranty () {
  if (!offers || offers.length === 0) {
    return
  }
  try {
    let result
    const cart = await fetch('/cart.js')
    await cart.json()
    if (window.selectedOffer) {
      result = await window.mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      )
      await window.mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...product,
          title: product.title,
          variantId: window.mulberryShop.selectedVariantId
        },
        window.selectedOffer.offer
      )
      window.pdpInline.deselectOffer()
      window.selectedOffer = null
      document.querySelector('.custom_drawer').classList.add('active')
    }
  } catch (err) {
    console.log('mulberry error: ', err)
  }
  window.mulberry.inline.deselectOffer()
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  console.log('warranty added')
  setTimeout(async () => {
    await removeAndSyncWarranties()
  }, 1200)
})

document.addEventListener('mulberry-shopify:loaded', async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners()
  await removeAndSyncWarranties()
  if (document.location.href.includes('/products/')) {
    mulberryPdpInit()
    let theVariant

    // Utility function to get URL parameters
    function getUrlParameter (name) {
      name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      const results = regex.exec(window.location.search)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }

    // Function to handle URL changes
    async function handleUrlChange () {
      const variant = getUrlParameter('variant')
      if (variant && theVariant !== variant) {
        theVariant = variant
        window.selectedOffer = null
        window.mulberryShop.selectedVariantId = variant
        const selectedVariant = getCurrentlySelectedVariant(product)
        if (selectedVariant) {
          const offers = await window.mulberry.core.getWarrantyOffer({
            id: selectedVariant.id,
            title: product.title,
            price: selectedVariant.price,
            detail: product
          })

          if (window.mulberry.core.settings.has_inline) {
            window.pdpInline.updateOffer(offers)
          }

          if (window.mulberry.core.settings.has_modal) {
            window.pdpModal.updateOffer(offers)
          }
        }
      }
    }

    // Override history.pushState and history.replaceState
    (function () {
      const originalPushState = window.history.pushState
      const originalReplaceState = window.history.replaceState

      window.history.pushState = function (...args) {
        originalPushState.apply(this, args)
        handleUrlChange()
      }

      window.history.replaceState = function (...args) {
        originalReplaceState.apply(this, args)
        handleUrlChange()
      }

      // Listen to popstate for back/forward button navigation
      window.addEventListener('popstate', handleUrlChange)
    })()

    // Initial call to handle URL change on page load
    handleUrlChange()
  }

  await window.mulberryShop.cart.init()
  window.mulberryShop.cart.render()
})

const handleClick = async () => {
  const HAS_MODAL = window.mulberry.core.settings.has_modal
  const HAS_INLINE = window.mulberry.core.settings.has_inline

  if (HAS_INLINE && window.selectedOffer) {
    await addWarranty()
  } else if (HAS_MODAL && !window.selectedOffer) {
    window.pdpModal.open()
  }
}

document.addEventListener('click', async function (event) {
  const targetButton = event.target.closest('.product-form__buttons button, .product-form__submit button')

  if (targetButton) {
    await handleClick()
  }
})

document.addEventListener('fetch:cart-change', async function () {
  if (requiresRebuild) {
    console.log('Mulberry cart change')
    setTimeout(async () => {
      // await removeAndSyncWarranties();
      mulberryUpdate = false
    }, 1200)
  }
})

document.addEventListener('fetch:cart-update', async function () {
  if (requiresRebuild) {
    if (!mulberryUpdate) {
      console.log('Mulberry cart update')
      setTimeout(async () => {
        await removeAndSyncWarranties()
      }, 1200)
    } else {
      mulberryUpdate = false
    }
  }
})

document.addEventListener('fetch:cart-add', async function () {
  if (requiresRebuild) {
    console.log('Mulberry cart add')
    setTimeout(async () => {
      // await removeAndSyncWarranties();
      mulberryUpdate = false
    }, 1200)
  }
})

async function removeAndSyncWarranties () {
  mulberryUpdate = true
  console.log('Mulberry cart sync')
  await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      const newItems = []
      const cartItems = firstCart.items
      for (const item of cartItems) {
        newItems.push(item)
      }
      firstCart.items = newItems
      window.mulberryShop
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then(async (newCart) => {
          window.mulberryShop.cart.syncQuantities(newCart).then(async (syncedCart) => {
            rebuildCart()
          })
        })
    })
  })
}

async function rebuildCart () {
  const cartDrawerElem = document.querySelector('cart-drawer')
  const cartNotificationElem = document.querySelector('cart-notification')
  const cartItemsElem = document.querySelector('cart-items')
  const pageToBuild = cartItemsElem || cartDrawerElem || cartNotificationElem
  const sectionsToRender = pageToBuild.getSectionsToRender()
  const sectionNames = []

  for (const sectionObj of sectionsToRender) {
    if (sectionObj.section) {
      sectionNames.push(sectionObj.section)
    } else if (sectionObj.id) {
      sectionNames.push(sectionObj.id)
    }
  }

  const queryParam = sectionNames.join(',')
  const latestCart = await fetch(`/cart?sections=${queryParam}`, {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  })
  const parsedState = await latestCart.json()

  if (cartNotificationElem) {
    cartNotificationElem.getSectionsToRender()?.forEach(section => {
      document.getElementById(section.id).innerHTML =
                cartNotificationElem?.getSectionInnerHTML(parsedState[section.id], section.selector)
    })
  }

  if (cartDrawerElem) {
    cartDrawerElem.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty')
    cartDrawerElem.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id)
      if (parsedState[section.id]) {
        sectionElement.innerHTML =
                    cartDrawerElem?.getSectionInnerHTML(parsedState[section.id], section.selector)
      }
    })
  }

  if (cartItemsElem) {
    cartItemsElem.getSectionsToRender().forEach(section => {
      const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
      elementToReplace.innerHTML =
                cartItemsElem?.getSectionInnerHTML(parsedState[section.section], section.selector);
      (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')))
    })
  }
}

function setupFetchListeners () {
  const { fetch: origFetch } = window
  window.fetch = async (...args) => {
    const response = await origFetch(...args)
    const requestUrl = args[0]
    if (requestUrl.includes('cart/change') || requestUrl.includes('cart/update') || requestUrl.includes('cart/add')) {
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes('cart/add')) {
            const fetchAddCustomEvent = new CustomEvent('fetch:cart-add')
            document.dispatchEvent(fetchAddCustomEvent)
          } else if (requestUrl.includes('cart/change')) {
            const fetchChangeCustomEvent = new CustomEvent('fetch:cart-change')
            document.dispatchEvent(fetchChangeCustomEvent)
          } else if (requestUrl.includes('cart/update')) {
            const fetchUpdateCustomEvent = new CustomEvent('fetch:cart-update')
            document.dispatchEvent(fetchUpdateCustomEvent)
          } else if (requestUrl.includes('cart.php')) {
            const fetchCartCustomEvent = new CustomEvent('fetch:cart-page')
            document.dispatchEvent(fetchCartCustomEvent)
          }
        })
        .catch((err) => console.error(err))
    }
    return response
  }
}
